import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Pinceauvernis = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.68 118.73">
  <G fill={color}>
    <Path d="M47.56,24.91V4.36c0-2.41-1.95-4.36-4.36-4.36H9.26c-2.41,0-4.36,1.95-4.36,4.36v20.56c-1.26.76-2.12,2.13-2.12,3.72v13.85c0,2.41,1.95,4.36,4.36,4.36h13.36v41.53c-1.41.43-2.55,1.55-2.95,3.03-2.03,7.57-10.08,14.82-15.95,19.61-1.43,1.17-1.97,3.1-1.35,4.84.62,1.74,2.26,2.89,4.1,2.89h21.29c1.16,0,2.27-.46,3.08-1.28,5.66-5.67,5.89-12.66,6.13-20.06.05-1.48.1-3.01.19-4.6.07-1.2-.35-2.37-1.18-3.25-.53-.56-1.19-.94-1.92-1.16v-41.54h13.36c2.41,0,4.36-1.95,4.36-4.36v-13.85c0-1.58-.85-2.96-2.12-3.72ZM26.15,97.1c-.2,6.07-.44,9.97-2.51,12.92h-7.95c3.77-3.88,7.17-8.28,9.18-13.14h1.3v.23ZM13.62,8.71h25.23v15.56H13.62v-15.56ZM40.97,38.12H11.5v-5.14h29.46v5.14Z"/>
  </G>
</Svg>
);
};

export default Pinceauvernis;
